<template>
  <div class="container d-flex justify-content-center align-items-center horizontal-scrollable flex-column">
    <h4 class="display-6 text-center mb-4 mt-4">
      Créditos por Departamento
      <br />
      <span v-if="departamentoSeleccionado">
        {{ departamentoSeleccionado }}
      </span>
      <span v-else>Carreta</span>
    </h4>

    <table class="table table-striped table-hover" id="myTable">
      <thead>
        <tr>
          <th>Index</th>
          <th>Beneficiario</th>
          <th class="text-center">DNI</th>
          <th>Saldo Capital</th>
          <th>Saldo Interes corriente (A la fecha)</th>
          <th class="text-center">Saldo Intereres Moratorio(A la fecha)</th>
          <th>Total Saldo Vencido a pagar(A la fecha)</th>
          <th>Total Saldo a pagar para cancelación(A la fecha)</th>
          <th>Asesor</th>
          <th>Sucursal</th>
        </tr>
      </thead>

      <tbody v-if="ready">
        <tr
          v-for="(credito, index) in creditosSafe"
          :key="credito.id || index"
          @click="irCredito(credito.cliente?.dni)"
          role="button"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ credito.cliente?.nombres || "" }}</td>
          <td class="text-center">{{ credito.cliente?.dni || "" }}</td>

          <td>{{ formatoNumero(credito.simularPagoHoy?.capitalDebePagar || 0) }} {{ moneda }}</td>
          <td>{{ formatoNumero(credito.simularPagoHoy?.saldoInteres || 0) }} {{ moneda }}</td>
          <td class="text-center">{{ formatoNumero(credito.simularPagoHoy?.saldoMora || 0) }} {{ moneda }}</td>

          <td>
            {{
              formatoNumero(
                credito.simularPagoHoy?.minimoDebePagarCuota
              )
            }}
            {{ moneda }}
          </td>

          <td>
            {{
              formatoNumero(
                (credito.saldo || 0) +
                  (credito.simularPagoHoy?.saldoInteres || 0) +
                  (credito.simularPagoHoy?.saldoMora || 0)
              )
            }}
            {{ moneda }}
          </td>

          <td>{{ credito.nombreAsesor || "" }}</td>
          <td>{{ credito.solicitud?.sucursal || credito.Solicitud?.Sucursal || "" }}</td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr>
          <td colspan="10" class="text-center">
            <div class="spinner-border text-warning text-center" role="status">
              <span class="visually-hidden text-center">Loading...</span>
            </div>
          </td>
        </tr>
      </tbody>

      <tfoot v-if="ready">
        <tr class="table-dark">
          <td colspan="3" class="text-end"><strong>Totales:</strong></td>
          <td>{{ formatoNumero(totalCapital) }} {{ moneda }}</td>
          <td>{{ formatoNumero(totalInteres) }} {{ moneda }}</td>
          <td>{{ formatoNumero(totalMora) }} {{ moneda }}</td>
          <td>{{ formatoNumero(totalAdeudado) }} {{ moneda }}</td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import DataTables from "datatables.net";
import Security from "../security";

const DEPARTAMENTO_A_SUCURSALES = {
  "FRANCISCO MORAZAN": ["FRANCISCO MORAZAN", "FRANCISCO MORAZAN AGRICOLA"],
  COPAN: ["COPAN"],
  ATLANTIDA: ["ATLANTIDA", "ATLANTIDA AGRICOLA"],
  OLANCHO: ["OLANCHO", "OLANCHO AGRICOLA"],
  LEMPIRA: ["LEMPIRA", "LEMPIRA AGRICOLA", "LEMPIRA/TOMALA", "LEMPIRA/ERANDIQUE"],
  YORO: ["YORO AGRICOLA"],
  COLON: ["COLON AGRICOLA"],
  INTIBUCA: ["INTIBUCA AGRICOLA"],
  OCOTEPEQUE: ["OCOTEPEQUE"],
  "SANTA BARBARA": ["SANTA BARBARA"],
  CHOLUTECA: ["CHOLUTECA AGRICOLA"],
  COMAYAGUA: ["COMAYAGUA AGRICOLA"],
  "EL PARAISO": ["EL PARAISO", "EL PARAISO AGRICOLA"],
};

export default {
  name: "TablaCreditosDepartamento",

  data() {
    return {
      creditos: [], // 👈 SIEMPRE array
      ready: false,
      moneda: "Lps",

      departamentoSeleccionado: "",
      asesorSeleccionado: null,
      estadoSeleccionado: "",
      tipoCarteraSeleccionado: 0,

      dataTableInstance: null,
    };
  },

  mounted() {
    this.leerQuery();
    this.cargarCreditos();
  },

  computed: {
    // ✅ Esto evita reduce sobre null
    creditosSafe() {
      return Array.isArray(this.creditos) ? this.creditos : [];
    },

    totalCapital() {
      return this.creditosSafe.reduce((s, c) => s + (Number(c.saldo) || 0), 0);
    },
    totalInteres() {
      return this.creditosSafe.reduce(
        (s, c) => s + (Number(c.simularPagoHoy?.saldoInteres) || 0),
        0
      );
    },
    totalMora() {
      return this.creditosSafe.reduce(
        (s, c) => s + (Number(c.simularPagoHoy?.saldoMora) || 0),
        0
      );
    },
    totalAdeudado() {
      return this.creditosSafe.reduce(
        (s, c) =>
          s +
          
          (Number(c.simularPagoHoy?.minimoDebePagarCuota) || 0) ,
          
        0
      );
    },
  },

  methods: {
    leerQuery() {
      this.departamentoSeleccionado =
        this.$route.query.departamento || this.$route.query.sucursal || "";

      this.asesorSeleccionado = this.$route.query.asesor
        ? parseInt(this.$route.query.asesor, 10)
        : null;

      this.tipoCarteraSeleccionado = this.$route.query.tipoCartera
        ? parseInt(this.$route.query.tipoCartera, 10)
        : 0;

      this.estadoSeleccionado = this.$route.query.estado || "Mostrar Todos";
    },

    norm(s) {
      return String(s || "").trim().toUpperCase();
    },

    expandirDepartamento(departamento) {
      const key = this.norm(departamento);
      const lista = DEPARTAMENTO_A_SUCURSALES[key];
      return lista && lista.length ? lista : [key];
    },

    aplicarPermisos(sucursalesDepto, userRoles0) {
      const permisos = Array.isArray(userRoles0)
        ? userRoles0.map((x) => this.norm(x))
        : [this.norm(userRoles0)];

      if (permisos.includes("ALL") || permisos.includes("")) return sucursalesDepto;

      const setPermisos = new Set(permisos);
      return sucursalesDepto.filter((s) => setPermisos.has(this.norm(s)));
    },

    async cargarCreditos() {
      try {
        this.ready = false;
        this.creditos = []; // ✅ reset

        // === obtené roles/permisos ===
        // Ajustá esta parte si vos lo guardás en otro lado.
        const raw = localStorage.getItem("userRoles");
        const userRoles = raw ? JSON.parse(raw) : [];
        const roles0 = userRoles?.[0] || "ALL";

        // === expandir departamento -> sucursales ===
        const sucursalesDepto = this.expandirDepartamento(this.departamentoSeleccionado);
        const sucursalesFinal = this.aplicarPermisos(sucursalesDepto, roles0);

        if (!sucursalesFinal.length) {
          this.ready = true;
          this.$nextTick(() => this.reiniciarDataTable());
          return;
        }

        const payload = {
          sucursal: "MOSTRAR TODAS",
          estado: this.estadoSeleccionado,
          asesor: this.asesorSeleccionado != null ? parseInt(this.asesorSeleccionado, 10) : null,
          sucursales: sucursalesFinal, // ✅ array filtrado
          tipoCartera: this.tipoCarteraSeleccionado,
        };

        const res = await fetch(
          process.env.VUE_APP_API_URL + "/admin/credito/all",
          Security.requestOptions(payload)
        );

        const json = await res.json();

        if (json?.error) {
          console.error("API error:", json);
          this.creditos = [];
        } else {
          const lista = json?.data?.creditos;
          this.creditos = Array.isArray(lista) ? lista.slice().reverse() : [];
        }

        this.ready = true;
        this.$nextTick(() => this.reiniciarDataTable());
      } catch (err) {
        console.error("fetch error:", err);
        this.creditos = []; // ✅ nunca null
        this.ready = true;
      }
    },

    reiniciarDataTable() {
      // destruir instancia anterior si existe
      if (this.dataTableInstance) {
        try {
          this.dataTableInstance.destroy();
        } catch (e) {
            console.warn("No se pudo destruir DataTable:", e);
        }
        this.dataTableInstance = null;
      }

      const myTable = document.querySelector("#myTable");
      if (myTable) {
        this.dataTableInstance = new DataTables(myTable);
      }
    },

    irCredito(dni) {
      if (!dni) return;
      this.guardarEnLocalStorage("busqueda", dni);
      window.location.href = "/cartera";
    },

    guardarEnLocalStorage(clave, valor, tamañoMaximo = 5 * 1024 * 1024) {
      const jsonString = JSON.stringify(valor);
      const tamañoJSON = new Blob([jsonString]).size;

      if (tamañoJSON <= tamañoMaximo) {
        localStorage.setItem(clave, jsonString);
      } else {
        console.error(
          `Error: El valor excede el tamaño máximo permitido de ${tamañoMaximo} bytes.`
        );
      }
    },

    formatoNumero(n) {
      return new Intl.NumberFormat("es-HN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);
    },
  },
};
</script>

<style scoped></style>